import { Navigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { useLanguage } from '../shared/LanguageContext'

function getPortalHome(userType, role) {
  if (role === 'ta') return '/ta'
  if (userType === 'parent') return '/parent'
  return '/student'
}

export default function ProtectedRoute({ children, allowedUserType, allowedRole, authDestination }) {
  const { isAuthenticated, loading, userType, role } = useAuth()
  const { t } = useLanguage()

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="spinner" />
          <p className="auth-loading-text">{t('loading')}</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    const authPath = authDestination === 'office-hours' ? '/auth?destination=office-hours' : '/auth'
    return <Navigate to={authPath} replace />
  }

  const redirect = getPortalHome(userType, role)
  if (allowedUserType && userType !== allowedUserType) {
    return <Navigate to={redirect} replace />
  }
  if (allowedUserType === 'student' && allowedRole !== 'ta' && role === 'ta') {
    return <Navigate to={redirect} replace />
  }
  if (allowedRole && role !== allowedRole) {
    return <Navigate to={redirect} replace />
  }

  return children
}
